import React from "react";

const LockOpen = (props) => {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    //     <path
    //        fillRule="evenodd"
    //        clipRule="evenodd"
    //        d="M18 8.5H17V6.5C17 3.74 14.76 1.5 12 1.5C9.24 1.5 7 3.74 7 6.5H9C9 4.84 10.34 3.5 12 3.5C13.66 3.5 15 4.84 15 6.5V8.5H6C4.9 8.5 4 9.4 4 10.5V20.5C4 21.6 4.9 22.5 6 22.5H18C19.1 22.5 20 21.6 20 20.5V10.5C20 9.4 19.1 8.5 18 8.5ZM6 20.5V10.5H18V20.5H6ZM14 15.5C14 16.6 13.1 17.5 12 17.5C10.9 17.5 10 16.6 10 15.5C10 14.4 10.9 13.5 12 13.5C13.1 13.5 14 14.4 14 15.5Z"
    //        fill={props.lockAllowed?"green":'orange'}
    //        fillOpacity="0.54" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        d="M8 0C9.72259 0 11.2309 1.01012 11.7819 2.50665C11.962 2.99609 11.6849 3.52979 11.1628 3.69871C10.6843 3.85355 10.166 3.64812 9.94419 3.23581L9.89129 3.11835C9.61841 2.37709 8.86867 1.875 8 1.875C6.96041 1.875 6.10607 2.61861 6.00916 3.56942L6 3.75L5.99867 6.25H13.3333C14.8061 6.25 16 7.36929 16 8.75V17.5C16 18.8807 14.8061 20 13.3333 20H2.66667C1.19391 20 0 18.8807 0 17.5V8.75C0 7.36929 1.19391 6.25 2.66667 6.25H3.99867L4 3.75C4 1.67893 5.79086 0 8 0ZM8 11.875C7.26362 11.875 6.66667 12.4346 6.66667 13.125C6.66667 13.8154 7.26362 14.375 8 14.375C8.73638 14.375 9.33333 13.8154 9.33333 13.125C9.33333 12.4346 8.73638 11.875 8 11.875Z"
        fill={props.lockAllowed?"green":'gray'}
      />
    </svg>
  );
};

export default LockOpen;
